var map = {
	"./img/about/about-arrow.svg": "ca20",
	"./img/about/about-bg-mobile.jpg": "cecb",
	"./img/about/about-bg-mobile.png": "6c20",
	"./img/about/about-bg.jpg": "6194",
	"./img/about/about-bg.png": "d739",
	"./img/about/about-bg.svg": "d9d3",
	"./img/about/about-image.jpg": "4072",
	"./img/about/about-image.png": "597e",
	"./img/about/about-info-img1.jpg": "af62",
	"./img/about/about-info-img2.jpg": "79c6",
	"./img/about/about-info-img3.jpg": "bd76",
	"./img/about/about-info-img4.jpg": "9bb4",
	"./img/about/about-intro-1.png": "d1fc",
	"./img/about/about-intro-2.png": "33e5",
	"./img/about/about-intro-words.png": "8965",
	"./img/about/about-loyalty.png": "dd13",
	"./img/about/about-service-1.jpg": "72ab",
	"./img/about/about-service-2.jpg": "8839",
	"./img/about/about-stocks.png": "aa71",
	"./img/about/about__logo.svg": "038a",
	"./img/about/about__loyalty-img.jpg": "4b78",
	"./img/about/banner-kz-mobile.jpg": "15ca",
	"./img/about/banner-kz.jpg": "7de6",
	"./img/about/banner-ru-mobile.jpg": "083a",
	"./img/about/banner-ru.jpg": "3c9d",
	"./img/about/cherries.svg": "6fd0",
	"./img/about/donut.svg": "70c0",
	"./img/about/heart-icon.svg": "c23b",
	"./img/about/like-icon.svg": "1799",
	"./img/about/magnum-daily.svg": "dcce",
	"./img/about/magnum-express.svg": "4d08",
	"./img/about/magnum-hyper.svg": "e279",
	"./img/about/magnum-super.svg": "77eb",
	"./img/about/magnum.svg": "f615",
	"./img/about/om.png": "b4ad",
	"./img/about/quality.jpg": "24c0",
	"./img/about/quality.png": "ed3b",
	"./img/about/service.jpg": "5207",
	"./img/about/service.png": "2a40",
	"./img/about/timer-icon.svg": "dfad",
	"./img/catalog/canned-food.png": "2bd0",
	"./img/catalog/childrens-products.png": "6b1b",
	"./img/catalog/confectionery.png": "d67a",
	"./img/catalog/dairy.png": "631e",
	"./img/catalog/frozen-food.png": "2677",
	"./img/catalog/fruits.png": "24ee",
	"./img/catalog/gastronomy.png": "617c",
	"./img/catalog/grocery.png": "3f51",
	"./img/catalog/household-chemicals.png": "7c8b",
	"./img/catalog/household-goods.png": "8410",
	"./img/catalog/hygiene-products.png": "b761",
	"./img/catalog/meat.png": "5c20",
	"./img/catalog/other-products.png": "bb5d",
	"./img/catalog/own-production.png": "c057",
	"./img/catalog/soft-drinks.png": "8988",
	"./img/catalog/tea.png": "5046",
	"./img/catalog/textile.png": "becb",
	"./img/club-page/app-gallery.png": "4533",
	"./img/club-page/app-gallery.svg": "3f31",
	"./img/club-page/app-store.png": "644f",
	"./img/club-page/arrow.png": "f9b3",
	"./img/club-page/arrow.svg": "80dd",
	"./img/club-page/aside.png": "0030",
	"./img/club-page/asidekz.png": "cd89",
	"./img/club-page/bad-case.png": "1959",
	"./img/club-page/bonus-1.svg": "bd04",
	"./img/club-page/bonus-3.svg": "8f31",
	"./img/club-page/cart-kz.png": "f4ce",
	"./img/club-page/cart.png": "f52f",
	"./img/club-page/cart2.png": "c5e5",
	"./img/club-page/close.svg": "4d33",
	"./img/club-page/club-benefit_phone.png": "10a0",
	"./img/club-page/club-loyalty-1.svg": "88f2",
	"./img/club-page/club-loyalty-2.svg": "18ed",
	"./img/club-page/club-loyalty-3.svg": "cf54",
	"./img/club-page/club-qr.svg": "5c82",
	"./img/club-page/club.png": "e992",
	"./img/club-page/google-play.png": "ad0a",
	"./img/club-page/logo.png": "2b53",
	"./img/club-page/main.png": "97bf",
	"./img/club-page/modal-kz.png": "ec3f",
	"./img/club-page/modal.png": "de72",
	"./img/club-page/new-qr-code.png": "aa6c",
	"./img/club-page/phone.png": "6b67",
	"./img/club-page/qr-code.png": "d9fa",
	"./img/club-page/qr-code.svg": "46ce",
	"./img/club-page/service-1.svg": "3ba6",
	"./img/club-page/service-2.svg": "cf5b",
	"./img/club-page/service-3.svg": "414d",
	"./img/club-page/service-4.svg": "c490",
	"./img/club-page/service-5.svg": "47d4",
	"./img/club-page/service-6.svg": "bdf3",
	"./img/club-page/service-7.svg": "88ac",
	"./img/club-page/service-8.svg": "b543",
	"./img/compliance/about.jpg": "3b4a",
	"./img/compliance/azamat.jpg": "e8ea",
	"./img/compliance/ethic.jpg": "9054",
	"./img/compliance/hero.jpg": "358f",
	"./img/compliance/speak.jpg": "c2d0",
	"./img/forum/1.png": "daca",
	"./img/forum/2.png": "e1de",
	"./img/forum/3.png": "a920",
	"./img/forum/almawine.svg": "ed6d",
	"./img/forum/bat.svg": "c8a9",
	"./img/forum/bg-right.png": "ec68",
	"./img/forum/bg-right.svg": "0ed3",
	"./img/forum/carl.svg": "f285",
	"./img/forum/cocacola.svg": "c926",
	"./img/forum/colgate.png": "96a4",
	"./img/forum/grants.png": "2a2f",
	"./img/forum/heineken.svg": "7128",
	"./img/forum/jacobs.png": "a5cb",
	"./img/forum/jelzin.png": "a2d6",
	"./img/forum/little-brazil.svg": "cb2d",
	"./img/forum/mars.svg": "90f8",
	"./img/forum/maxi.png": "ffa4",
	"./img/forum/mondelez.svg": "164a",
	"./img/forum/monkey.png": "30d6",
	"./img/forum/rgbrands.png": "ccb1",
	"./img/forum/tanuki.svg": "0438",
	"./img/forum/tiger.svg": "2874",
	"./img/gsp/banner-mob.png": "6e78",
	"./img/gsp/banner.png": "bc82",
	"./img/gsp/gsp-arrow.svg": "0d11",
	"./img/gsp/gsp-magnum.svg": "a7b8",
	"./img/gsp/lemon.svg": "b55a",
	"./img/icons/404.png": "89da",
	"./img/icons/appeal.png": "b430",
	"./img/icons/arrow-gray.svg": "935d",
	"./img/icons/arrow-home.svg": "da03",
	"./img/icons/arrow-icon-banner.svg": "3f40",
	"./img/icons/arrow-slider-prev.svg": "cb44",
	"./img/icons/arrow-slider.svg": "7cb2",
	"./img/icons/arrow-up.svg": "5200",
	"./img/icons/arrow.svg": "3c0a",
	"./img/icons/bakery.svg": "fcf7",
	"./img/icons/banner-icons.svg": "382f",
	"./img/icons/banner-text.svg": "1bfb",
	"./img/icons/banner-wings.svg": "1e06",
	"./img/icons/best_price-icon-black.svg": "08e1",
	"./img/icons/best_price-icon-white.svg": "3040",
	"./img/icons/best_price-icon.svg": "df759",
	"./img/icons/book-icon.svg": "c8f0",
	"./img/icons/bookmark.svg": "4e1b",
	"./img/icons/check-icon.svg": "1564",
	"./img/icons/checked.svg": "8ab9",
	"./img/icons/circle.svg": "bcfb",
	"./img/icons/close-btn.svg": "4cd9",
	"./img/icons/close-white.svg": "0349",
	"./img/icons/close.svg": "6282",
	"./img/icons/coffee.svg": "166a",
	"./img/icons/complexity.svg": "5957",
	"./img/icons/coordinates.svg": "754f",
	"./img/icons/discount.svg": "38d6",
	"./img/icons/eye.svg": "45c2",
	"./img/icons/favicon.svg": "91b5",
	"./img/icons/fb.png": "5b9c",
	"./img/icons/filter-gray.svg": "fa46",
	"./img/icons/filter-red.svg": "eaf8",
	"./img/icons/filter-white.svg": "a5c0",
	"./img/icons/filter.svg": "8e90",
	"./img/icons/fish.svg": "f116",
	"./img/icons/img_placeholder.svg": "f7d7",
	"./img/icons/insta.png": "a723",
	"./img/icons/juice.svg": "4906",
	"./img/icons/link.svg": "7c12",
	"./img/icons/logo-footer-uz.svg": "db93",
	"./img/icons/logo-footer.svg": "1771",
	"./img/icons/logo-mobile.svg": "7caa",
	"./img/icons/logo.svg": "aa0d",
	"./img/icons/magnum-chef.svg": "adff",
	"./img/icons/magnum-club__logo.svg": "457a",
	"./img/icons/magnum-corp.svg": "66c4",
	"./img/icons/magnum-go-logo.svg": "a0a5",
	"./img/icons/magnum-pdf.svg": "7273",
	"./img/icons/mandarin.svg": "f7a3",
	"./img/icons/meat.svg": "9eaf",
	"./img/icons/menu-btn.svg": "b4ac",
	"./img/icons/next-orange.svg": "f430",
	"./img/icons/next-purple.svg": "b7b9",
	"./img/icons/next-red.svg": "d196",
	"./img/icons/next-white-red.svg": "8189",
	"./img/icons/next-white.svg": "8847",
	"./img/icons/next.svg": "fc55",
	"./img/icons/ok.png": "7fad",
	"./img/icons/ornament.svg": "ae0f",
	"./img/icons/placeholder.svg": "421e",
	"./img/icons/prev-white.svg": "82bb",
	"./img/icons/prev.svg": "fba8",
	"./img/icons/print.svg": "6feb",
	"./img/icons/quote.svg": "4373",
	"./img/icons/red-arrow-left.svg": "926c",
	"./img/icons/scroll-top-arrow.svg": "4321",
	"./img/icons/search-pink.svg": "0f38",
	"./img/icons/search.svg": "0930",
	"./img/icons/shops-arrow-gray.svg": "4dd9",
	"./img/icons/shops-arrow.svg": "d785",
	"./img/icons/sort-icon.svg": "daa0",
	"./img/icons/telegram.png": "4b82",
	"./img/icons/tiktok.png": "c694",
	"./img/icons/tomato.svg": "79fa",
	"./img/icons/twitter.png": "9e04",
	"./img/icons/views-gray.svg": "2ab1",
	"./img/icons/vk.png": "4a70",
	"./img/icons/whatsapp.png": "77b9",
	"./img/magnum-career/bg-mobile.jpg": "3269",
	"./img/magnum-career/bg.jpg": "52ec",
	"./img/magnum-career/close.svg": "4193",
	"./img/magnum-career/come.png": "9a94",
	"./img/magnum-career/logo-bg.svg": "be49",
	"./img/magnum-career/modal.svg": "5b7d",
	"./img/magnum-career/warranty.png": "c61a",
	"./img/magnum-club/app-gallery.png": "31a7",
	"./img/magnum-club/app-store.png": "d5cd",
	"./img/magnum-club/bg.jpg": "d489",
	"./img/magnum-club/close.svg": "faed",
	"./img/magnum-club/desktop.png": "98f4",
	"./img/magnum-club/gallery.png": "e89a",
	"./img/magnum-club/google-play.png": "adda",
	"./img/magnum-club/magnum-club__bg.jpg": "3f78",
	"./img/magnum-club/magnum-club__cart.png": "3c06",
	"./img/magnum-club/magnum-club__red.svg": "02a6",
	"./img/magnum-club/mobile-desktop.png": "a22b",
	"./img/magnum-club/mobile.png": "09aa",
	"./img/magnum-club/title-mobile.svg": "14b7",
	"./img/magnum-club/title.jpg": "934b",
	"./img/magnum-corp/corp__intro.png": "fa85",
	"./img/magnum-go/advantages.jpg": "9e6d",
	"./img/magnum-go/aside.jpg": "16bf",
	"./img/magnum-go/hero-mobile.png": "c5fc",
	"./img/magnum-go/hero.png": "91dd",
	"./img/magnum-go/logo-MG.svg": "c041",
	"./img/magnum-go/logo.svg": "a84a",
	"./img/magnum-go/phone.png": "c2e2",
	"./img/magnum-promo/promo-1.png": "489a",
	"./img/magnum-promo/promo-2.png": "f688",
	"./img/magnum-promo/promo-3.png": "b2df",
	"./img/magnum-promo/promo-4.png": "97b0",
	"./img/magnum-promo/promo-5.png": "1953",
	"./img/magnum-promo/promo-6.png": "f33a",
	"./img/our-brands/magnum.svg": "9636",
	"./img/own-production/arrow.svg": "525b",
	"./img/recipes/slide-mobile-uz.png": "444b",
	"./img/recipes/slide-mobile.png": "1ad7",
	"./img/recipes/slide-uz.png": "531a",
	"./img/recipes/slide.png": "a7db",
	"./img/search/404.svg": "300f",
	"./img/shop/bakery.svg": "21b8",
	"./img/shop/coffee.svg": "96c6",
	"./img/shop/express.png": "cb5f",
	"./img/shop/fish.svg": "13ec",
	"./img/shop/juice.svg": "3743",
	"./img/shop/logo.svg": "d74f",
	"./img/shop/magnum-daily.svg": "846a",
	"./img/shop/magnum-express.svg": "1704",
	"./img/shop/magnum-super.svg": "cf03",
	"./img/shop/magnum.svg": "ba50",
	"./img/shop/meat.svg": "cca1",
	"./img/shops/slide-1.png": "270f",
	"./img/stocks/basket.png": "278e",
	"./img/stocks/magnum-club.svg": "6d10",
	"./img/stocks/magnum.svg": "b787",
	"./img/stocks/popcorn.svg": "9dc4",
	"./img/stocks/qr-decore.svg": "9475",
	"./img/stocks/qr.svg": "b5cc",
	"./img/stocks/slide-2.jpg": "d125",
	"./img/stocks/slide.jpg": "4f0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72b0";